import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fc3f8bde")

_pushScopeId("data-v-fc3f8bde")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = {
  key: 0,
  class: "file-statgov"
}
const _hoisted_5 = {
  key: 0,
  class: "window"
}
const _hoisted_6 = { class: "modal" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", null, "загружено!", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.files.data, (file, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "file-statgov",
              key: index
            }, [
              _createVNode("p", null, _toDisplayString(index + 1) + ". " + _toDisplayString(file.termNames), 1),
              _createVNode("button", {
                class: "download",
                onClick: $event => (_ctx.pushFile(file))
              }, " Загрузить ", 8, ["onClick"])
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          (_ctx.checkNofile)
            ? (_openBlock(), _createBlock("div", _hoisted_4, "Нет данные"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withId(() => [
        (_ctx.modalIsActive)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode("button", {
                  class: "ok",
                  onClick: _cache[1] || (_cache[1] = $event => (_ctx.modalIsActive = !_ctx.modalIsActive))
                }, "Оk")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64 /* STABLE_FRAGMENT */))
})